/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PublicBookingShowPathParams, PublicBookingShowResponse } from '../types/PublicBookingShow'

/**
 * GET /interview-scheduling/booking/:tokenString
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::show
 */
export async function publicBookingShow(
	tokenString: PublicBookingShowPathParams['tokenString'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicBookingShowResponse>> {
	return axiosInstance.get(`/interview-scheduling/booking/${tokenString}`, config)
}
